var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 648,
    height: 44,
    viewBox: "0 0 648 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_nf_172_3446)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_172_3446",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00012 0H644V8C644 23.0849 644 30.6274 639.314 35.3137C634.628 40 627.085 40 612 40H36.0001C20.9152 40 13.3727 40 8.68641 35.3137C4.00012 30.6274 4.00012 23.0849 4.00012 8V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.00012 0H644V8C644 23.0849 644 30.6274 639.314 35.3137C634.628 40 627.085 40 612 40H36.0001C20.9152 40 13.3727 40 8.68641 35.3137C4.00012 30.6274 4.00012 23.0849 4.00012 8V0Z",
    fill: "url(#paint0_radial_172_3446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00012 0H644H4.00012ZM652 24C652 37.2548 641.255 48 628 48H20.0001C6.74529 48 -3.99988 37.2548 -3.99988 24H12.0001C12.0001 28.4183 15.5818 32 20.0001 32H628C632.418 32 636 28.4183 636 24H652ZM20.0001 48C6.74529 48 -3.99988 37.2548 -3.99988 24V0H12.0001V24C12.0001 28.4183 15.5818 32 20.0001 32V48ZM652 0V24C652 37.2548 641.255 48 628 48V32C632.418 32 636 28.4183 636 24V0H652Z",
    fill: "url(#paint1_linear_172_3446)",
    mask: "url(#path-1-inside-1_172_3446)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_nf_172_3446",
    x: 0.00012207,
    y: -4,
    width: 648,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.66666668653488159 0.66666668653488159",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 8635
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_172_3446"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  })), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_172_3446"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_172_3446",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(234.5 -14.6667) rotate(6.45083) scale(1143.74 419.746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBCA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_172_3446",
    x1: 324,
    y1: 0,
    x2: 324,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEBE5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBar);
export default __webpack_public_path__ + "static/media/top_bar.d37c16ce0d12804e5d90282d37fc3387.svg";
export { ForwardRef as ReactComponent };